import { useMeeting } from "@videosdk.live/react-sdk";
import PubSubHandler from "../PubSubHandler";
import PersonalDetailSection from "./PersonalDetailSection";
import PolicyDetailSection from "./PolicyDetailSection";
import VideoConsentSection from "./VideoConsentSection";
import QnaSection from "./QnaSection";
import DisagreePage from "../../pages/DisagreePage";
import Thankyou from "../../pages/Thankyou";
import { useState } from "react";
import { useAppContext } from "../../AppContextDef";
import IntroPageSkeleton from "../skeleton/IntroPageSkeleton";
import ConfirmBox from "../ConfirmBox";
import { useTranslation } from "react-i18next";

const RecordingContainer = ({
  formattedTime,
  currentPage,
  isDisagreeButtonClick,
}) => {
  const {
    openErrorBox, setOpenErrorBox, openJourneyLimitBox, setOpenJourneyLimitBox,
    isRecorderNetworkUnstable,
  } = useAppContext();
  const { runningTimeData } = useAppContext()
  const [joined, setJoined] = useState(null);
  const [characterJoined, setCharacterJoined] = useState(false);
  const { t } = useTranslation();


  function onMeetingJoined() {
    setJoined("JOINED");
  }

  const { meetingId } = useMeeting({
    onMeetingJoined,
  });

  return (
    joined === "JOINED" && (
      <>
        <PubSubHandler />
        {currentPage === "PersonalDetails" && (
          <PersonalDetailSection
            formattedTime={runningTimeData ? runningTimeData : formattedTime}
            characterJoined={characterJoined}
            setCharacterJoined={setCharacterJoined}
          />
        )}
        {currentPage === "PolicyDetails" && (
          <PolicyDetailSection
            formattedTime={runningTimeData ? runningTimeData : formattedTime}
            characterJoined={characterJoined}
          />
        )}
        {currentPage === "VideoConsent" && (
          <VideoConsentSection
            formattedTime={runningTimeData ? runningTimeData : formattedTime}
            characterJoined={characterJoined}
          />
        )}
        {currentPage === "QnA" && (
          <QnaSection formattedTime={runningTimeData ? runningTimeData : formattedTime} />
        )}
        {isDisagreeButtonClick?.isDisagreeClick && (
          <DisagreePage isPubSubPage={true} />
        )}
        {currentPage === "Thankyou" && <Thankyou isPubSubPage={true} />}
        {currentPage === null && <IntroPageSkeleton />}
        {openErrorBox && (
          <ConfirmBox
            open={openErrorBox}
            setOpen={setOpenErrorBox}
            buttonText={`${t("Close")}`}
            buttonHandler={async () => {
              setOpenErrorBox(false)
            }}
            text={t(
              "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]"
            )}
          />
        )}
        {openJourneyLimitBox && (
          <ConfirmBox
            open={openJourneyLimitBox}
            setOpen={setOpenJourneyLimitBox}
            text={t(
              "Your journey is about to expire in one minute. Please complete any pending actions."
            )}
            buttonText={t("Close")}
            buttonHandler={async () => {
              setOpenJourneyLimitBox(false)
            }}
          />
        )}
        {/* Recorder-observed network instability — blocking dialog shown on
            every recorder page; auto-dismisses when the network recovers. */}
        {isRecorderNetworkUnstable && (
          <ConfirmBox
            open={isRecorderNetworkUnstable}
            showButton={false}
            text={t(
              "Your network connection is unstable and too weak to continue. Please switch to a better network to resume the session."
            )}
          />
        )}
      </>
    )
  );
};

export default RecordingContainer;
